import React from "react";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

import { Heading1 } from "../../Typography";
import { Image } from "../..";
import { getSponsors } from "../../../_entities/Slides/Slides.selectors";

const Credits = () => {
  const sponsors = useSelector(getSponsors);

  const parent = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  const child = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        duration: 1,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  const sponsorParent = {
    initial: { y: 1000 },
    animate: {
      y: 0,
      transition: {
        staggerChildren: 0.5,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  const sponsorChild = {
    initial: { y: 1000 },
    animate: {
      y: 0,
      transition: {
        duration: 1,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  return (
    <div style={{ background: "black", padding: "1rem" }}>
      <div className="w-100 vh-100 flex flex-column justify-around items-center pa2 white">
        <motion.div
          variants={parent}
          initial="initial"
          animate="animate"
          className="w-100 flex flex-column justify-center items-center"
        >
          <motion.div variants={child} className="w-10 mb4">
            <Image
              src={`https://bwsj-dev-api-upload.s3.amazonaws.com/BWSJ_logo_white_222b624880.svg`}
              fallback={`https://bwsj-dev-api-upload.s3.amazonaws.com/BWSJ_logo_white_222b624880.svg`}
              type={`image/svg+xml`}
            />
          </motion.div>
          <Heading1 variants={child}>THANK YOU TO OUR SPONSORS</Heading1>
        </motion.div>

        <motion.div
          variants={sponsorParent}
          initial="initial"
          animate="animate"
          className="w-100 flex flex-wrap justify-center items-center"
        >
          {sponsors?.map((sponsor) => (
            <motion.div
              variants={sponsorChild}
              key={sponsor?.id}
              className="w-20 pa5"
            >
              <Image
                src={sponsor?.logo?.url}
                fallback={sponsor?.logo?.url}
                type={sponsor?.logo?.mime}
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Credits;
